import { useEffect, useState } from "react";

export const RUNNING_MESSAGES = {
  products: [
    "Lendo o documento...",
    "Identificando produtos e serviços ofertados...",
    "Extraindo proposta de valor e diferenciais...",
  ],
  audiences: [
    "Analisando linguagem e contexto...",
    "Identificando perfis de público-alvo...",
    "Mapeando dores, desejos e objeções...",
  ],
  brandVoice: [
    "Lendo trechos representativos...",
    "Detectando o tom de voz da marca...",
    "Selecionando palavras recorrentes...",
  ],
} as const;

export type ExtractionPhase = keyof typeof RUNNING_MESSAGES;

export function useRotatingMessage(active: boolean, key: ExtractionPhase): string {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!active) {
      setIdx(0);
      return;
    }
    const list = RUNNING_MESSAGES[key];
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), 2200);
    return () => clearInterval(t);
  }, [active, key]);
  return RUNNING_MESSAGES[key][idx];
}
